<template>
  <div class="container" v-if="showTabs">
      <div class="row">
        <div class="w-auto mx-auto">
          <nav class="nav nav-pills flex-row media-tabs">
            <span class="flex-fill text-center nav-link"
                  :class="{ active: currentTab === checkinTabs.BUYABLE }"
                  @click="onSelect(checkinTabs.BUYABLE)">
              {{ $t('pages.checkins_detail.not_purchased_yet') }}
            </span>
            <span class="flex-fill text-center nav-link"
                  :class="{ active: currentTab === checkinTabs.BOUGHT }"
                  @click="onSelect(checkinTabs.BOUGHT)">
                  {{ $t('pages.checkins_detail.purchased') }} ({{ unlockedGalleriesMediasCount }})
                </span>
          </nav>
        </div>
      </div>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import {checkinTabs} from "@/domain/media/galleries/constants";

export default {
  name: "MediaTabs",
  emits: ['select'],
  data() {
    return {
      currentTab: checkinTabs.BOUGHT
    }
  },
  watch: {
    paidGalleriesMediasCount: {
      immediate: true,
      handler(value) {
        if (value > 0) {
          this.onSelect(checkinTabs.BUYABLE)
        }
      }
    }
  },
  computed: {
    ...mapGetters('galleries', [
      'unlockedGalleriesMediasCount',
      'paidGalleriesMediasCount'
    ]),
    checkinTabs() {
      return checkinTabs
    },
    showTabs() {
      return this.unlockedGalleriesMediasCount > 0 && this.paidGalleriesMediasCount > 0
    }
  },
  methods: {
    onSelect(tab) {
      this.currentTab = tab
      this.$emit('select', tab)
    }
  }
}
</script>



<style scoped>

</style>